import {createRequest} from "../submodules/naoo-web-components/Api/createRequest";

const getUsers = (params) => createRequest('main', 'get', '/users', null, params)

const getSelf = () => createRequest('main', 'get', '/users/self ', null)

export { getUsers, getSelf }